<nav class="navbar bg-dark navbar-expand-lg bg-body-tertiary no-print" data-bs-theme="dark">
    <div class="container-fluid">
        <a class="navbar-brand" [routerLink]="['../list']"><i class="fa-solid fa-qrcode me-2"></i><span class="manual">Manual</span>Radar</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link active" aria-current="page" [routerLink]="['../codes']">QR Codes</a>
                </li>
            </ul>
            <span class="navbar-text me-3 text-muted">v{{ environment.appVersion }}</span>
            <span class="navbar-text text-white">Angemeldet als {{accessService.client?.name}}</span>

            <button type="button" class="btn btn-secondary mx-3" (click)="showClientModal()"><i class="fa fa-user-tie"></i></button>
            <button type="button" class="btn btn-secondary me-3" (click)="logout()">Abmelden</button>
        </div>
    </div>
</nav>

<div bsModal #clientModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left">Mandant</h4>
                <button type="button" class="btn-close close pull-right" aria-label="Close"
                        (click)="closeClientModal()">
                    <span aria-hidden="true" class="visually-hidden">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="client">
                <form>
                    <div class="mb-3">
                        <label class="form-label">Name</label>
                        <input type="text" class="form-control" name="clientname" [(ngModel)]="client.name" required>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">E-Mail</label>
                        <input type="text" class="form-control" name="clientemail" [(ngModel)]="client.email" required>
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Passwort</label>
                        <input type="password" class="form-control" name="clientpassword"
                               [(ngModel)]="client.password">
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Passwort bestätigen</label>
                        <input type="password" class="form-control" name="clientpasswordconfirm"
                               [(ngModel)]="client.passwordConfirm">
                    </div>
                </form>
            </div>
            <div class="modal-footer" *ngIf="client">
                <button type="button" class="btn btn-success"
                        (click)="updateClient()" [disabled]="!client.name || !client.email || client.password != client.passwordConfirm">
                    Aktualisieren
                </button>
                <button type="button" class="btn btn-secondary float-end"
                        (click)="closeClientModal()">
                    Schließen
                </button>
            </div>
        </div>
    </div>
</div>
